import DateList from "src/dataTypes/dates/DateList";
import DateOperators from "src/operators/dates/DateOperators";
import NumberList from "src/dataTypes/numeric/NumberList";
import Interval from "src/dataTypes/numeric/Interval";
import IntervalList from "src/dataTypes/numeric/IntervalList";

/**
 * @classdesc  StringList Conversions
 *
 * @namespace
 * @category strings
 */
function StringListConversions() {}
export default StringListConversions;


/**
 * Converts StringLIst to numberList
 *
 * @param {StringList} stringlist StringList to convert
 */
StringListConversions.StringListToNumberList = function(stringlist) {
  var numbers = new NumberList();
  numbers.name = stringlist.name;
  var i;
  for(i = 0; stringlist[i] != null; i++) {
    numbers[i] = Number(stringlist[i]);
  }
  return numbers;
};

/**
 * Converts StringLIst to numberList
 *
 * @param {StringList} stringlist StringList to convert
 */
StringListConversions.toNumberList = function(stringlist) {
  return StringListConversions.StringListToNumberList(stringlist);
}

/**
 * converts a stringList into a dateList
 *
 * @param {StringList} stringlist StringList to convert
 * @param  {String} formatCase format cases:<|>0: MM-DD-YYYY<|>1: YYYY-MM-DD<|>2: MM-DD-YY<|>3: YY-MM-DD<|>4: DD-MM-YY<|>5: DD-MM-YYYY
 * @param  {String} separator "-" by default
 * @return {DateList}
 * tags:
 */
StringListConversions.toDateList = function(stringList, formatCase, separator) {
  if(stringList==null) return;
  
  var dateList = new DateList();
  dateList.name = stringList.name;
  var i;
  var l = stringList.length;
  for(i = 0; i<l; i++) {
    dateList.push(DateOperators.stringToDate(stringList[i], formatCase, separator));
  }
  return dateList;
};

/**
 * converts a stringList into an intervalList provided the strings have the proper form
 *
 * @param {StringList} stringlist StringList to convert
 *
 * @param  {Interval} invalidValue is the value to use for elements that are not valid intervals. Default is the empty interval [0,0]
 * @return {IntervalList}
 * tags:
 */
StringListConversions.toIntervalList = function(stringList, invalidValue) {
  if(stringList==null) return;

  invalidValue = invalidValue == null ? new Interval(0,0) : invalidValue;
  var intList = new IntervalList();
  intList.name = stringList.name;
  var i;
  var l = stringList.length;
  for(i = 0; i<l; i++){
    var aParts = stringList[i].match(/Interval\[x\:([\d\.]+)\| y\:([\d\.]+).*/);
    if(aParts == null || isNaN(aParts[1]) || isNaN(aParts[2]))
      intList.push(invalidValue.clone());
    else
      intList.push(new Interval(Number(aParts[1]),Number(aParts[2])));
  }
  return intList;
};
